
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import S from '@/store'
import * as T from '@/types'
import chroma from 'chroma-js'

import AppLogo from '@/components/app/AppLogo.vue'
import AppReleaseInfo from '@/components/app/AppReleaseInfo.vue'
import UserDropdown from '@/components/app/UserDropdown.vue'

import {
    UiButtonCollection,
    UiCard,
    UiFormattedText,
    UiIconButton,
    UiModal,
} from '@hubsolv/hubsolv-ui'

@Component({
    components: {
        AppLogo,
        AppReleaseInfo,
        UiButtonCollection,
        UiCard,
        UiFormattedText,
        UiIconButton,
        UiModal,
        UserDropdown,
    },
})
export default class AppHeader extends Vue {

    ////////////////////////////////////////////////////////////////
    // Vuex bindings
    ////////////////////////////////////////////////////////////////
    
    @S.Auth.Getter rememberedEmail!: string
    @S.Auth.Getter me!: T.User
    @S.Auth.Action logout!: any

    @S.Files.Getter loading!: string

    ////////////////////////////////////////////////////////////////
    // data
    ////////////////////////////////////////////////////////////////
    
    showReleaseInfo: boolean = false

    ////////////////////////////////////////////////////////////////
    // computed → color
    ////////////////////////////////////////////////////////////////

    get color () {
        return 'cd-blue'
    }

    get classes () {
        return [
            this.color,
        ]
    }

    get light () {
        return this.color !== 'white'
    }

    get firstLogin () {
        return this.$route.query.showFirstLogin === 'true'
    }

    get filesLoading () {
        return this.loading
    }

    get routes () {
        return [
            {   
                label: 'Files',
                icon: 'file',
                route: {
                    name: T.CrmRoute.VIEW_FILES,
                },
            },
            {
                label: 'Cases',
                icon: 'briefcase-account',
                route: {
                    name: T.CrmRoute.VIEW_CASES,
                },
            },
        ]
    }

    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////
    
    @Watch('loading')
    showPopup (newLoading: any, oldLoading:any) {
        if (oldLoading === true && newLoading === false)
        if (this.firstLogin){
            this.showReleaseInfo = true
        } 
    }

    onCloseReleaseInfo () {
        this.showReleaseInfo = false
        this.$router.push(this.$route.path)
    }
    
}
